import { getOtpList, createOtp as apiCreate, updateOtp as apiUpdate, deleteOtp as apiDelete } from '@/api/otp'
import { getGroupList as apiGetGroupList, createGroup as apiCreateGroup, updateGroup as apiUpdateGroup, deleteGroup as apiDeleteGroup } from '@/api/otp'
import { generateTotpCode, getRemainingSeconds } from '@/utils/totp'

const state = {
  otpList: [],
  groups: [],
  activeGroup: '',
  totpCodes: {},
  timerHandle: null
}

const getters = {
  filteredList: state => {
    if (!state.activeGroup) return state.otpList
    return state.otpList.filter(item => item.group_name === state.activeGroup)
  }
}

const mutations = {
  SET_OTP_LIST(state, { items, groups }) {
    state.otpList = items
    state.groups = groups
  },
  SET_GROUPS(state, groups) {
    state.groups = groups
  },
  SET_ACTIVE_GROUP(state, group) {
    state.activeGroup = group
  },
  ADD_OTP(state, item) {
    state.otpList.push(item)
  },
  UPDATE_OTP(state, updated) {
    const idx = state.otpList.findIndex(i => i.id === updated.id)
    if (idx !== -1) {
      state.otpList.splice(idx, 1, updated)
    }
  },
  REMOVE_OTP(state, id) {
    state.otpList = state.otpList.filter(i => i.id !== id)
    const newCodes = { ...state.totpCodes }
    delete newCodes[id]
    state.totpCodes = newCodes
  },
  SET_TOTP_CODES(state, codes) {
    state.totpCodes = codes
  },
  UPDATE_TOTP_CODE(state, { id, code, remaining }) {
    const existing = state.totpCodes[id] || {}
    state.totpCodes = {
      ...state.totpCodes,
      [id]: {
        ...existing,
        code: code !== undefined ? code : existing.code,
        remaining: remaining !== undefined ? remaining : existing.remaining
      }
    }
  },
  SET_TIMER(state, handle) {
    state.timerHandle = handle
  }
}

const actions = {
  async fetchOtpList({ commit }) {
    const res = await getOtpList()
    commit('SET_OTP_LIST', res.data)
    return res
  },

  async createOtp({ dispatch }, data) {
    const res = await apiCreate(data)
    await dispatch('fetchOtpList')
    return res
  },

  async updateOtp({ dispatch }, { id, data }) {
    const res = await apiUpdate(id, data)
    await dispatch('fetchOtpList')
    return res
  },

  async deleteOtp({ commit, dispatch }, id) {
    const res = await apiDelete(id)
    commit('REMOVE_OTP', id)
    return res
  },

  async fetchGroupList({ commit }) {
    const res = await apiGetGroupList()
    commit('SET_GROUPS', res.data)
    return res
  },

  async createGroup({ dispatch }, data) {
    const res = await apiCreateGroup(data)
    await dispatch('fetchOtpList')
    return res
  },

  async updateGroup({ dispatch }, { id, data }) {
    const res = await apiUpdateGroup(id, data)
    await dispatch('fetchOtpList')
    return res
  },

  async deleteGroup({ dispatch }, { id, data }) {
    const res = await apiDeleteGroup(id, data)
    await dispatch('fetchOtpList')
    return res
  },

  startTotpTimer({ state, commit }) {
    if (state.timerHandle) return

    const update = () => {
      const codes = {}
      state.otpList.forEach(item => {
        const code = generateTotpCode(item.secret, {
          digits: item.digits,
          period: item.period,
          algorithm: item.algorithm
        })
        const remaining = getRemainingSeconds(item.period)
        codes[item.id] = { code, remaining, period: item.period }
      })
      commit('SET_TOTP_CODES', codes)
    }

    update()
    const handle = setInterval(update, 1000)
    commit('SET_TIMER', handle)
  },

  stopTotpTimer({ state, commit }) {
    if (state.timerHandle) {
      clearInterval(state.timerHandle)
      commit('SET_TIMER', null)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
